import React from "react"

const Icon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="110" viewBox="0 0 24 120" fill="none">
    <path
      d="M20 77L18.59 75.59L13 81.17V0H11V81.17L5.42 75.58L4 77L12 85L20 77Z"
      fill="url(#paint0_linear_1383_5928)"
    />
    <defs>
      <linearGradient id="paint0_linear_1383_5928" x1="12" y1="0" x2="12" y2="85" gradientUnits="userSpaceOnUse">
        <stop stopColor="#757575" stopOpacity="0" />
        <stop offset="1" stopColor="#757575" />
      </linearGradient>
    </defs>
  </svg>
)

export default Icon
